import { getSerializableSession } from './authHelper'
import { formatSessionData } from '../mappers/userMapper'

export const USER_SESSION_STORAGE_KEY = 'brandDnaUserSession'

export const clearUserSession = () => window.sessionStorage.clear()

export const getUserSession = () => {
  const storedSession = window.sessionStorage.getItem(USER_SESSION_STORAGE_KEY)

  if (!storedSession) return {}

  try {
    return JSON.parse(storedSession)
  } catch {
    window.sessionStorage.removeItem(USER_SESSION_STORAGE_KEY)
    return {}
  }
}

export const saveUserSession = (session) => {
  const userSession = {
    ...formatSessionData(getSerializableSession(session)),
    isLoggedIn: true,
  }

  window.sessionStorage.setItem(
    USER_SESSION_STORAGE_KEY,
    JSON.stringify(userSession),
  )

  return userSession
}
